import DriverList from '@/pages/driver/DriverList'
import AddDriver from '@/pages/driver/AddDriver'
import DriverDetail from '@/pages/driver/DriverDetail'
import DriverMonitorV2 from '@/pages/driver/DriverMonitorV2'
import DriverTrajectory from '@/pages/driver/DriverTrajectory'
import WorkingStatus from '@/pages/download/WorkingStatus'

import ShiftArea from '@/pages/area/ShiftArea'

import GroupList from '@/pages/group/GroupList'
import AddGroup from '@/pages/group/AddGroup'
import GroupDetail from '@/pages/group/GroupDetail'

import ManagerList from '@/pages/manager/ManagerList'
import AddManager from '@/pages/manager/AddManagerNew'
import AbilityManagement from '@/pages/manager/AbilityManagement'
import ManagerDetail from '@/pages/manager/ManagerDetailNew'
import ServerDetail from '@/pages/manager/ServerDetail'

import TransactionList from '@/pages/transaction/TransactionList'

import TransactionDetail from '@/pages/transaction/TransactionDetail'
import TransactionStatistic from '@/pages/transaction/TransactionStatistic'

import Board from '@/pages/announcement/Board'
import BoardEditor from '@/pages/announcement/BoardEditor'
import BoardDetail from '@/pages/announcement/BoardDetail'

import MessageEditor from '@/pages/message/MessageEditor'
import MessageList from '@/pages/message/MessageList'
import MessageDetail from '@/pages/message/MessageDetail'

import PaymentList from '@/pages/payment/PayDriverBill'

import StoreList from '@/pages/specialContract/StoreList'
import AddStore from '@/pages/specialContract/AddStore'

import CustomerList from '@/pages/customer/CustomerList'
import CustomerInfo from '@/pages/customer/CustomerInfo'

import PhoneHail from '@/pages/hailTaxi/PhoneHail'
import HailStateV2 from '@/pages/hailState/HailStateV2'

import Landmark from '@/pages/landmark/LandmarkEdit'
import ServiceMain from '@/pages/ServiceMain'

import LoginInfoList from '@/pages/manager/LoginInfoList'
import EditStore from '@/pages/specialContract/EditStore'

import ReservationList from '@/pages/reservation/ReservationList'
import DispatchArea from '@/pages/area/DispatchArea_modify'
import ShiftBoard from '@/pages/area/ShiftBoard'

import RecordHailBill from '@/pages/recordHail/RecordHailBill'
import MobilePay from '@/pages/mobilePay/payList'
import PregnantService from '@/pages/pregnantService/PregnantService'
import DriverBehavior from '@/pages/driver/DriverBehavior'
import DriverDistribution from '@/pages/driver/DriverDistribution'
import CompanyList from '@/pages/company/CompanyList'
import CompanyDetail from '@/pages/company/CompanyDetail'
import AddWithdrawal from '@/pages/company/AddWithdrawal'
import AddInvoice from '@/pages/company/AddInvoice'
import EditInvoice from '@/pages/company/EditInvoice'
import EditWithdrawal from '@/pages/company/EditWithdrawal'

import LongTermCareUserList from '@/pages/longTermCare/UserList'
import LongTermCareNewUserForm from '@/pages/longTermCare/NewUserForm'
import LongTermCareEditUserForm from '@/pages/longTermCare/EditUserForm'
import LongTermCareUserDetail from '@/pages/longTermCare/UserDetail'

import LongTermCareOrderList from '@/pages/longTermCare/OrderList'
import NewLongTermCareOrderForm from '@/pages/longTermCare/NewOrderForm'
import MakeupLongTermCareOrderForm from '@/pages/longTermCare/MakeupOrderForm'
import EditLongTermCareOrderForm from '@/pages/longTermCare/EditOrderForm'
import LongTermCareOrderDetail from '@/pages/longTermCare/OrderDetail'
import TeamBuildLocation from '@/pages/teamBuildLocation/TeamBuildLocation'
import CustomerComplaint from '@/pages/manager/CustomerComplaint'
import ShiftBoardOld from '@/pages/area/ShiftBoard_old'
import ActivityRecord from '@/pages/activityRecord/ActivityRecord'
import SearchDriverMeter from '@/pages/driver/SearchDriverMeter'

import StoredItem from '@/pages/stored/StoredItem'
import StoreRecord from '@/pages/stored/StoreRecord'

export default [
  {
    path: '/serviceMain',
    name: 'Servicemain',
    component: ServiceMain,
    children: [
      {
        path: '/long-term-users',
        name: 'longTermUserList',
        component: LongTermCareUserList,
        meta: {
          title: '長照用戶管理',
        },
      },
      {
        path: 'stored-item',
        name: 'stored-item',
        component: StoredItem,
        meta: {
          title: '儲值設定',
        },
      },
      {
        path: 'stored-record',
        name: 'stored-record',
        component: StoreRecord,
        meta: {
          title: '儲值/扣款紀錄',
        },
      },
      {
        path: '/long-term-users/new',
        name: 'newLongTermUser',
        component: LongTermCareNewUserForm,
        meta: {
          title: '新增長照用戶',
        },
      },
      {
        path: '/long-term-users/:id',
        name: 'longTermUserDetail',
        component: LongTermCareUserDetail,
        meta: {
          title: '檢視長照用戶',
        },
      },
      {
        path: '/long-term-users/:id/edit',
        name: 'editLongTermUser',
        component: LongTermCareEditUserForm,
        meta: {
          title: '編輯長照用戶',
        },
      },
      {
        path: '/long-term-orders',
        name: 'longTermOrderList',
        component: LongTermCareOrderList,
        meta: {
          title: '長照單管理',
        },
      },
      {
        path: '/long-term-orders/new',
        name: 'newLongTermOrder',
        component: NewLongTermCareOrderForm,
        meta: {
          title: '預約長照單',
        },
      },
      {
        path: '/long-term-orders/makeup',
        name: 'makeupLongTermOrder',
        component: MakeupLongTermCareOrderForm,
        meta: {
          title: '補長照單',
        },
      },
      {
        path: '/long-term-orders/:orderId/edit',
        name: 'editLongTermOrderForm',
        component: EditLongTermCareOrderForm,
        meta: {
          title: '編輯長照單',
        },
      },
      {
        path: '/long-term-orders/:orderId',
        name: 'longTermOrderDetail',
        component: LongTermCareOrderDetail,
        meta: {
          title: '檢視長照單',
        },
      },
      {
        path: 'board',
        name: 'Board',
        component: Board,
        meta: {
          title: '公告',
        },
      },
      {
        path: 'driverList',
        name: 'driverList',
        component: DriverList,
        meta: {
          title: '司機資料',
        },
      },
      {
        path: 'addDriver',
        name: 'addDriver',
        component: AddDriver,
      },
      {
        path: 'driver/:id',
        name: 'driverDetail',
        component: DriverDetail,
        meta: {
          title: '司機詳細資料',
        },
      },
      {
        path: 'ShiftArea',
        name: 'ShiftArea',
        component: ShiftArea,
        meta: {
          title: '排班站',
        },
      },
      /* {
        path: 'DriverMonitor',
        name: 'DriverMonitor',
        component: DriverMonitor,
        meta: {
          title: '圖台監控',
        },
      }, */
      {
        path: 'DriverMonitorV2',
        name: 'DriverMonitorV2',
        component: DriverMonitorV2,
        meta: {
          title: '圖台監控',
        },
      },
      {
        path: 'DriverTrajectory',
        name: 'DriverTrajectory',
        component: DriverTrajectory,
        meta: {
          title: '行程軌跡',
        },
      },
      {
        path: 'groupList',
        name: 'GroupList',
        component: GroupList,
      },
      {
        path: 'addGroup',
        name: 'AddGroup',
        component: AddGroup,
      },
      {
        path: 'group/:id',
        name: 'GroupDetail',
        component: GroupDetail,
      },
      {
        path: 'managerList',
        name: 'ManagerList',
        component: ManagerList,
        meta: {
          title: '使用者管理',
        },
      },
      {
        path: 'WorkingStatus',
        name: 'WorkingStatus',
        component: WorkingStatus,
        meta: {
          title: '大量作業進度',
        },
      },

      {
        path: 'addManager',
        name: 'AddManager',
        component: AddManager,
      },
      {
        path: 'manager/:id',
        name: 'ManagerDetail',
        component: ManagerDetail,
      },
      {
        path: 'server/:id',
        name: 'ServerDetail',
        component: ServerDetail,
        meta: {
          title: '叫車紀錄',
        },
      },
      {
        path: 'transactionList',
        name: 'TransactionList',
        component: TransactionList,
        meta: {
          title: '叫車記錄總查詢',
          keepAlive: true,
        },
      },
      /* 目前沒有使用v2，之後可以考慮刪除 */
      /* {
        path: 'transactionList_V2',
        name: 'TransactionList_V2',
        component: TransactionList_V2,
        meta: {
          title: '叫車記錄',
          keepAlive: true,
        },
      }, */
      {
        path: 'transaction/:id',
        name: 'transactionDetail',
        component: TransactionDetail,
        meta: {
          title: '叫車記錄',
        },
      },
      {
        path: 'transactionStatistic',
        name: 'TransactionStatistic',
        component: TransactionStatistic,
        meta: {
          title: '派車單月統計',
        },
      },
      {
        path: 'phoneHail',
        name: 'PhoneHail',
        component: PhoneHail,
        meta: {
          title: '電話派車',
        },
      },
      {
        path: 'hailStateV2',
        name: 'HailStateV2',
        component: HailStateV2,
        meta: {
          title: '叫車紀錄',
        },
      },
      {
        path: 'boardEditor',
        name: 'BoardEditor',
        component: BoardEditor,
        meta: {
          title: '公告',
        },
      },
      {
        path: 'board/:id',
        name: 'BoardDetail',
        component: BoardDetail,
        meta: {
          title: '公告',
        },
      },
      {
        path: 'customerList',
        name: 'CustomerList',
        component: CustomerList,
        meta: {
          title: '乘客會員資料',
        },
      },
      {
        path: 'customerInfo',
        name: 'CustomerInfo',
        component: CustomerInfo,
        meta: {
          title: '乘客會員資料',
        },
      },
      {
        path: 'landmarkList',
        name: 'LandmarkList',
        component: Landmark,
        meta: {
          title: '自訂地標',
        },
      },
      {
        path: 'messageEditor',
        name: 'MessageEditor',
        component: MessageEditor,
        meta: {
          title: '傳送訊息紀錄',
        },
      },
      {
        path: 'messageList',
        name: 'MessageList',
        component: MessageList,
        meta: {
          title: '傳送訊息紀錄',
        },
      },
      {
        path: 'messageList/:id',
        name: 'MessageDetail',
        component: MessageDetail,
        meta: {
          title: '傳送訊息紀錄',
        },
      },
      {
        path: 'storeList',
        name: 'StoreList',
        component: StoreList,
        meta: {
          title: '特約店家',
        },
      },
      {
        path: 'AddStore',
        name: 'AddStore',
        component: AddStore,
        meta: {
          title: '特約店家',
        },
      },
      {
        path: 'LoginInfoList',
        name: 'LoginInfoList',
        component: LoginInfoList,
        meta: {
          title: '使用者紀錄',
        },
      },
      {
        path: 'EditStore/:id',
        name: 'EditStore',
        component: EditStore,
        meta: {
          title: '修改商家',
        },
      },
      {
        path: 'ReservationList',
        name: 'ReservationList',
        component: ReservationList,
        meta: {
          title: '預約單',
        },
      },
      {
        path: 'DispatchArea',
        name: 'DispatchArea',
        component: DispatchArea,
        meta: {
          title: '派遣區',
        },
      },
      {
        path: 'ShiftBoard',
        name: 'ShiftBoard',
        component: ShiftBoard,
        meta: {
          title: '排班區看板',
        },
      },
      {
        path: 'RecordHailBill',
        name: 'RecordHailBill',
        component: RecordHailBill,
        meta: {
          title: '後派單',
        },
      },
      {
        path: 'mobilePay',
        name: 'mobilePay',
        component: MobilePay,
        meta: {
          title: '行動支付付款紀錄',
        },
      },
      {
        path: 'pregnantService',
        name: 'pregnantService',
        component: PregnantService,
        meta: {
          title: '孕婦乘車',
        },
      },
      {
        path: 'driverBehavior/:debug?',
        name: 'driverBehavior',
        component: DriverBehavior,
        meta: {
          title: '司機使用查詢',
        },
      },
      {
        path: 'driverDistribution',
        name: 'driverDistribution',
        component: DriverDistribution,
        meta: {
          title: '歷史分佈圖',
        },
      },
      {
        path: 'paymentList',
        name: 'PaymentList',
        component: PaymentList,
      },
      {
        path: 'AbilityManagement',
        name: 'AbilityManagement',
        component: AbilityManagement,
        meta: {
          title: '職位管理',
        },
      },
      {
        path: 'companyList',
        name: 'companyList',
        component: CompanyList,
        meta: {
          title: '企業用戶',
          keepAlive: true,
        },
      },
      {
        path: 'companyDetail',
        name: 'companyDetail',
        component: CompanyDetail,
        meta: {
          title: '企業資料與電子簽單',
        },
      },
      {
        path: 'addWithdrawal',
        name: 'addWithdrawal',
        component: AddWithdrawal,
        meta: {
          title: '新增領款單',
        },
      },
      {
        path: 'addInvoice',
        name: 'addInvoice',
        component: AddInvoice,
        meta: {
          title: '新增企業請款單',
        },
      },
      {
        path: 'editInvoice',
        name: 'editInvoice',
        component: EditInvoice,
        meta: {
          title: '編輯企業請款單',
        },
      },
      {
        path: 'editWithdrawal/:id',
        name: 'editWithdrawal',
        component: EditWithdrawal,
        meta: {
          title: '編輯請款單',
        },
      },
      {
        path: 'teamBuildLocation',
        name: 'teamBuildLocation',
        component: TeamBuildLocation,
        meta: {
          title: '自建交叉路口',
        },
      },
      {
        path: 'customerComplaint',
        name: 'CustomerComplaint',
        component: CustomerComplaint,
        meta: {
          title: '客訴管理',
        },
      },
      {
        path: 'ShiftBoard_v1',
        name: 'ShiftBoard_v1',
        component: ShiftBoardOld,
        meta: {
          title: '排班區看板',
        },
      },
      {
        path: 'activityRecord',
        name: 'activityRecord',
        component: ActivityRecord,
        meta: {
          title: '活動紀錄',
        },
      },
      {
        path: 'SearchDriverMeter',
        name: 'SearchDriverMeter',
        component: SearchDriverMeter,
        meta: {
          title: '查詢跳錶紀錄',
        },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/pages/page_404.vue'),
  },
  {
    path: '*',
    redirect: '/404',
  },
]



// WEBPACK FOOTER //
// ./src/router/allRoutersTable.js